// extracted by mini-css-extract-plugin
export default {"logo":"AppBar_component_logo__RY9+O"};